<template>
<transition name="slide">
  <div @click.self="closePopup" class="modal-box-wrapper" v-if="isOpen">
    <div class="modal-box" v-if="isOpen">
      <div class="modal-box--content">
        <span class="modal-box--closing-button icon yule-icon-close-small" @click="closePopup"></span>
        <div v-if="item.business_card_image_url" >
          <img :src="item.business_card_image_url" alt="business card" :onerror="'this.onerror=null; this.src=\'' + this.image + '\';'"/>
        </div>
        <div class="no_image" v-else>
          <img :src="image" alt="no image associated">
        </div>
      </div>
    </div>
  </div>
</transition>
</template>
<script>
import { EventBus } from '@/EventBus.js';
import LeadCreate from '@/components/pages/project/leads/LeadCreate'
import image from '@/assets/empty-business-card.svg'


export default{
  props: ['item','open'],
  data(){
    return{
      isOpen: false,
      image
    }
  },
  components: {LeadCreate},
  mounted(){
    this.isOpen = this.open
  },
  methods: {
    closePopup(){
      this.isOpen = false
    },
    openPopup(){
      this.isOpen = true
    },
  },
  watch: {
    open() {
      this.isOpen = true
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-box--closing-button {
  top: 30px;
  right: 30px;
  background: $color-white;
}
.modal-box{
  max-height: 80%;
  position: relative;
  img {
    max-width: 100%;
  }
}
.modal-box--content{
  max-width: 600px;
}
</style>



// WEBPACK FOOTER //
// BusinessCardPopup.vue?5c0ebfa3